
export const InputControls = {
  NONE: 'none',
  DROPDOWN: 'dropdown',
  INTERVAL: 'interval',
} as const;